// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"241":"bf340f35","245":"35101e3a","496":"13e61439","653":"bafd8d76","891":"e60d0f74"}[chunkId] + ".chunk.js";
};